import React, { useMemo } from "react";
import Select from "react-select";
import "./CountrySelectCustom.css"; // Opcional, para estilos propios

const CountrySelectCustom = ({
  countryList,
  value,
  onChange,
  placeholder,
  label,
  isDisabled = false,
}) => {
  const options = useMemo(() => {
    if (!countryList) return [];
    return countryList.map((c) => ({ value: c.value, label: c.label }));
  }, [countryList]);

  const selected = useMemo(() => {
    return options.find((opt) => opt.value === value) || null;
  }, [options, value]);

  const handleChange = (opt) => {
    onChange(opt ? opt.value : "");
  };

  return (
    <div className="country-select-wrapper">
      {label && <label className="country-select-label">{label}</label>}
      <Select
        isDisabled={isDisabled}
        options={options}
        value={selected}
        onChange={handleChange}
        placeholder={placeholder || "Select a country"}
      />
    </div>
  );
};

export default CountrySelectCustom;
